import React, { useEffect, useState } from 'react';

export const usePanel = (() => {
  const listeners: React.Dispatch<React.SetStateAction<string>>[] = [];
  let state = '';
  const setState: React.Dispatch<string> = newState => {
    state = newState;

    listeners.forEach(
      (listener: React.Dispatch<React.SetStateAction<string>>) => {
        listener(state);
      },
    );
  };
  return (): [string, React.Dispatch<string>] => {
    const [, newListener] = useState('');
    useEffect(() => {
      listeners.push(newListener);
    }, []);
    return [state, setState];
  };
})();
